import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import type { StaffViewModel } from "lobbie";
import { buildResourcePathForCurrentUser } from "../ResourceBuilder";
import type { RootState } from "../store";

const staffApi = createApi({
    reducerPath: "lobbie/account/staff",
    baseQuery: fetchBaseQuery({}), // TODO: buildResourcePathForCurrentUser builds the url path in it's entirety because api fetching is spread out everywhere atm
    endpoints: (builder) => ({
        getStaffForAccount: builder.query<StaffViewModel[], void>({
            queryFn: async (_, api) => {
                const fetchUrl = buildResourcePathForCurrentUser(
                    api.getState() as RootState,
                    "/account/staff",
                );
                return await axios.get<StaffViewModel[]>(fetchUrl, { withCredentials: true });
            },
        }),
    }),
});

export const { useGetStaffForAccountQuery } = staffApi;

export default staffApi;
